import { Field, Form, Formik,useField,ErrorMessage } from "formik";
import React, { useId, useState } from "react";
import * as Yup from "yup";
import Asterisk from "../../../../components/asterisk/Asterisk";
import { BackButton, Submit } from "../../../../components/button/buttons";
import { TextInput } from "../../../../components/input/inputs";
import IMAGES from "../../../../assets/images/images";  
import { FormFieldLabel as Label,FormErrorLabel as ErrorLabel, FormImgAvailableLabel, FormImgErrorLabel } from "../../../../components/label/Labels";
import { Sidebar } from "../../../../components/sidebar/Sidebar";
import styles from "./NewUser.module.css";
import { Alert } from "../../../../components/alert/alerts";
import { USER_TYPE } from "../../../../utils/constants/userConstants";
import * as DOMPurify from 'dompurify';
import { capitalizeWords } from "../../../../utils/utils";
import Tooltip from "../../../../components/toolTip/toolTip";
import { IncidentServiceTypes, Incident_Service_Type_Values } from "../../../../utils/constants/incidentConstants";
import { FUNCTIONAL_ROLE_ENUM } from "../../../../utils/constants/userManagementConstant"
import SectionGuard from "../../../../hoc/guards/SectionGuard";
import CAN from "../../../../casl/can";
import { Action, Resource } from "../../../../casl/constants";
import { Loader } from "../../../../components/loader/Loader";
const FieldWrapper = ({ children }) => {
  return <div className={styles.fieldContainer}>{children}</div>;
};

const TextField = ({ label, placeholder, checkAvailability,customError,isCheckingEmail, ...props }) => {
  const [field, meta, helpers] = useField(props);
  const hasError = meta.touched && meta.error ? true : false;
  const inputStyle = hasError ? styles.inputError : checkAvailability === true ? styles.textavailable : styles.textfield;
  return (
    <FieldWrapper>
      <div>
        <Label text={label} />
        <Asterisk />
      </div>
      <TextInput  {...field}  {...props} placeholder={placeholder}   style={inputStyle}  onChange={props.onChange}/>
      {isCheckingEmail ? (<div className={styles.loaderclass}><span><Loader loaderStyle={styles.loader}/></span><span>Verifying email</span></div>)
       :(<div>
      {hasError ? (
        customError ? (
        <FormImgErrorLabel text={meta.error} />
       ) : (<ErrorLabel text={meta.error} />)
       ) : checkAvailability === true ? (
        <FormImgAvailableLabel text="Available"/>
       ) : checkAvailability === false ? (
        <FormImgErrorLabel text="This Email Address exists. Try another"/>
       ):null }</div>)}
    </FieldWrapper>
  );
};


const PhoneNumberTextField = ({ label, placeholder, ...props }) => {
  return (
    <FieldWrapper>
      <div>
        <Label text={label} />
      </div>
      <TextInput {...props} placeholder={placeholder} />
    </FieldWrapper>
  );
};

const CheckBox = ({ name, value, label,checked, onChange }) => {
  const id = useId();
  return (
    <div className={styles.radioField}>
      <Field
        id={id}
        className={styles.radioInput}
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      <label htmlFor={id} className={styles.radioLabel}>
        {label}
      </label>
    </div>
  );
};
const ButtonWrapper = ({ children }) => {
  return <div className={styles.buttonContainer}>{children}</div>;
};



const NewUser = ({customerData,userData=null,isEdit,...props}) => {
  const {functionalRoles,userList}=props;
  const [serviceType,setServiceType] = useState(customerData?.serviceSpecificDetails.map((item)=>item.serviceType.value))
  const hasIvcService = customerData?.serviceSpecificDetails.some(service => service.serviceType?.value === Incident_Service_Type_Values.IVC_Service);
  const hasIpxService = customerData?.serviceSpecificDetails.some(service => service.serviceType?.value === Incident_Service_Type_Values.IPX_Service);
  const rolesToShow = hasIpxService && serviceType?.length===1 && serviceType[0]==="ipx_service" ? functionalRoles?.filter(role => role.id !== FUNCTIONAL_ROLE_ENUM.REGULATORY) : hasIvcService && serviceType?.length===1 && serviceType[0]==="ivc_service"
      ? functionalRoles?.filter(role => role.id === FUNCTIONAL_ROLE_ENUM.INCIDENT_MANAGEMENT || role.id === FUNCTIONAL_ROLE_ENUM.USER_MANAGEMENT || role.id === FUNCTIONAL_ROLE_ENUM.DASHBOARD || role.id === FUNCTIONAL_ROLE_ENUM.REGULATORY)
      : functionalRoles;
  const [showAddUser, setShowAddUser] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  let [isAlert, setIsAlert] = useState(false);
  const [message, setMessage] = useState({
    message: "",
    image: IMAGES.success
  });
  // const [errorMsg,setErrorMsg] = useState("")
  let existingEmails = userList?.map((existing) => existing.email);
  const [checkAvailability, setAvailability] = useState(null);
  const [isCheckingEmail, setIsCheckingEmail] = useState(false);

  const handleCustomBlur = async (e,handleBlur,errors) => {
  const value = e.target.value?.trim();
  handleBlur(e);
  if (e.target.name !== "email") return;
  const hasYupErrorNow = !!errors?.email;
  if (!value || hasYupErrorNow) {
    setAvailability(null);
    return;
  }
try {
    setIsCheckingEmail(true); 
    const result = await props.getEmailToVerify(value);
    const isValidEmail = result?.res?.data?.isEmailPresentInOnboardingReqest === false && result?.res?.data?.isEmailPresentInRights === false;
    setAvailability(isValidEmail);
} catch (err) {
    setAvailability(null);
  } finally {
    setIsCheckingEmail(false);
  }
  };

  let availedService = customerData?.serviceSpecificDetails?.map((detail)=>detail?.serviceType?.value);

  const getCPName=()=>{
    let cpName=null;
    let data=customerData?.serviceSpecificDetails?.filter((item) => {
      return item?.serviceType?.value == Incident_Service_Type_Values.IPX_Service;
    })
    if(data.length>0){
      cpName=data[0]?.cpName
    }
    return cpName;
  }

  const getIVCAccountDetails=()=>{
    let ivcAccountDetails={
      accountAbbr:null,
      accountNumber:null
    };
    let data=customerData?.serviceSpecificDetails?.filter((item) => {
      return item?.serviceType?.value == Incident_Service_Type_Values.IVC_Service;
    })
    if(data.length>0){
      ivcAccountDetails.accountAbbr=data[0]?.accountAbbr
      ivcAccountDetails.accountNumber=data[0]?.accountNumber
    }
    return ivcAccountDetails;
  }

  let initialValues={}
  

  if (isEdit) {
    initialValues = {
      email: userData.email,
      fullName: userData.displayName,
      phoneNumber: null,
      assignModule: "manual",
      userType: "customer",
      functionalRoles: userData.functionalRoles,
      serviceType: userData?.customerUserMetaInfo?.myServices?.map((item)=>item?.serviceType?.value)    
    }
  }else{
    initialValues = {
      email: "",
      fullName: "",
      phoneNumber: null,
      assignModule: "manual",
      userType: "customer",
      functionalRoles: [],
      serviceType: availedService?.length == 1 ? availedService : []   // set default value if only one service is availed     
    }
  }


  const getEmailDomain=(email)=>{
    return email?email.split("@")[1]:"";
  }
  
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(/^\S(.*\S)?$/, "Space not allowed at start and end")
      .email("Invalid email")
      .max(100, "Email must be at most 100 characters")
      .required("Required")
      .test(
        'Domain Validate',
        `User email domain must be same as the primary contact email domain (${getEmailDomain(customerData?.serviceSpecificDetails[0].primaryContacts[0].email)})`,
        function (value) {
          const primaryEmailDomain = getEmailDomain(customerData?.serviceSpecificDetails[0].primaryContacts[0].email);
          const userEmailDomain = getEmailDomain(value);
          return primaryEmailDomain?.toLowerCase() === userEmailDomain?.toLowerCase();  //CUP-2744
        }
      ),
      // .test(
      //   'unique',
      //   'This Email Address exists. Try another',
      //   function (value) {
      //     if (isEdit) return true;
      //     return !existingEmails?.includes(value);
      //   }
      // ),
    
  // .test({
  //   name: 'Edit Restriction',
  //   message: "You cannot update your own permissions.",
  //   test: function(value) {
  //     if (isEdit && value === props?.myRights?.email) {
  //       setErrorMsg("You cannot update your own permissions.");
  //       return false;
  //     }
  //     return true;
  //   }
  // }),
    fullName: Yup.string()
    .matches(/^\S(.*\S)?$/, "Space not allowed at start and end")
      .min(2, "Too Short!")
      .max(100,"Name must be at most 100 characters")
      .required("Required"),
    phoneNumber: Yup.string().matches(/^(\+\d{1,3}[- ]?)?\d{10}$/, "Invalid mobile number").nullable(true),
    functionalRoles:Yup.array().min(1,"Please select at least one role."),
    serviceType:Yup.array().min(1,"Please select at least one service type.").max(1)
  });

  const close = () => {
    setIsSubmit(false);
    setShowAddUser(false);
    setAvailability(null); 
    // setErrorMsg("");
  };
  const addUser=(obj)=>{
    props.createUser(obj).then((result) => {
      if (result.status) {
        setMessage({
          message: "New user added successfully!",
          image: IMAGES.success
        });
        setIsSubmit(false);
        close();
        props.openAlertPopup({
          message: "New user added successfully!",
          image: IMAGES.success
        });
        let searchKey = "";
        let type = USER_TYPE.CUSTOMER;
        let custID = customerData?.uniqueCustomerRefId;
        let next=null;
        props.getUser(type, custID, searchKey,next);
      } else {
        setIsSubmit(false);
        let error_msg = result?.error;
        close();
        setMessage({
          message: error_msg,
          image: IMAGES.error
        });
        props.openAlertPopup({
          message: error_msg,
          image: IMAGES.error
        });
      }
    })
      .catch((error) => {
        setIsSubmit(false);
        close();
        setMessage({
          message: "An error occurred while processing your request. Please try again later.",
          image: IMAGES.error
        });
        props.openAlertPopup({
          message: "An error occurred while processing your request. Please try again later.",
          image: IMAGES.error
        });
       // Alert.showAlert(message.message, message.image);
      //  setIsAlert(true);
      });
  }

  const updateUser=(obj)=>{
    let values={
      functionalRoles:obj.functionalRoles,
     // myServices:obj.myServices,
     // cpName:obj.cpName,
      userType:USER_TYPE.CUSTOMER
    }
    props.updateUserPermissions(values, userData.uid)
    .then((result) => {
      if (result.status) {
        setMessage({
          message: "User permissions updated successfully!",
          image: IMAGES.success
        });
        setIsSubmit(false);
        close();
        props.openAlertPopup({
          message: "User permissions updated successfully!",
          image: IMAGES.success
        });
        let searchKey = "";
        let type = USER_TYPE.CUSTOMER;
        let custID = customerData?.uniqueCustomerRefId;
        let next=null;
        props.getUser(type, custID, searchKey,next);
      } else {
        setIsSubmit(false);
        let error_msg = result?.error;
        close();
        setMessage({
          message: error_msg,
          image: IMAGES.error
        });
        props.openAlertPopup({
          message: error_msg,
          image: IMAGES.error
        });
      }
    })
    .catch((error) => {
      setIsSubmit(false);
        close();
        setMessage({
          message: "An error occurred while processing your request. Please try again later.",
          image: IMAGES.error
        });
        props.openAlertPopup({
          message: "An error occurred while processing your request. Please try again later.",
          image: IMAGES.error
        });
    });
  }


  return (
    <div>
      {isEdit ? (
        <div   onClick={props.icon ? () => setShowAddUser(true) : null}
        className={props.icon ? styles.addButtons : styles.addButtonsnot}> {userData?.email===props.myRights.email?<img className={styles.editrole} src={IMAGES.eyeicon} />:<img className={props.icon ? styles.editrole : styles.addButtonsnot} src={IMAGES.editrole} />}</div>  
      ) : (
        <SectionGuard canAccess={CAN(Action.CREATE, Resource.RIGHTS)}>
         <button
          onClick={() => {setShowAddUser(true)
                         setAvailability(null)}}
          className={styles.addButton}>
          Add New User
         </button>
        </SectionGuard>
      )}
      {showAddUser && (
        <Sidebar
          isOpen={showAddUser}
          headerTxt={`${isEdit?userData?.email===props.myRights.email?"View Access":"Edit Access":"Add New User"}`}
          onClose={close}
          sideNavStyle={styles.sideNavStyle}
          >
          
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            validateOnChange
            onSubmit={async (values, { resetForm }) => {    
              values.fullName = values?.fullName?.trim();
              values.phoneNumber = null; 
              values.cpName = values.serviceType?.indexOf(Incident_Service_Type_Values.IPX_Service)!= -1 ? getCPName() : null;  
              values.email = values?.email?.toLowerCase();             
              values.uniqueCustomerRefId = customerData?.uniqueCustomerRefId;
              let obj = JSON.parse(JSON.stringify(values));
              obj.myServices = values.serviceType.map(item => {
                if (item === Incident_Service_Type_Values.IPX_Service) {
                  return {
                    serviceType: item,
                    cpName: getCPName()
                  };
                }
                else {
                  let ivcAccountDetails = getIVCAccountDetails()
                  return {
                    serviceType: item,
                    cpName: null,
                    accountAbbr: ivcAccountDetails.accountAbbr,
                    accountNumber: ivcAccountDetails.accountNumber
                  }
                }
              });
          
              delete obj.assignModule; 
              delete obj.serviceType; 
              setIsSubmit(true);
               
              if(isEdit){
                updateUser(obj);
              }else{
                addUser(obj);
              }
             
            }}
          >
            {({
              isValid,
              dirty,
              setFieldValue,
              values,
              handleChange,
              handleBlur,
              setFieldError,
              setFieldTouched,
              errors
            }) => (
              <Form className={styles.form}>
                <fieldset  className={styles.scroll}>
                  <TextField
                    label="Email Address"
                    name="email"
                    type="text"
                    placeholder="Input text"
                    onChange={(e) => {
                      handleChange(e);                 
                      setAvailability(null);
                      // setFieldValue('fullName','')
                    }}
                    onBlur={(e)=>handleCustomBlur(e,handleBlur,errors,setFieldError,setFieldTouched)}       
                    disabled={isEdit}
                    customError={true}
                    checkAvailability={checkAvailability} 
                    isCheckingEmail={isCheckingEmail}
                  />
                  <TextField
                    label="Full Name"
                    name="fullName"
                    type="text"
                    placeholder="Input text"
                    //onChange={handleChange}
                    onBlur={handleBlur}
                    onChange={(e)=>{
                      setFieldValue("fullName",capitalizeWords(e.target.value));
                      }}
                    disabled={isEdit}
                    customError={false}
                    // checkAvailability={false} 
                  />
                  {/*<PhoneNumberTextField
                    label="Mobile number"
                    name="phoneNumber"
                    type="text"
                    placeholder="XXXXX XXXXX"
                    onChange={handleChange}
                    onBlur={handleBlur}
            />*/}
            {/* {availedService?.length>1 ? (
          <div className={styles.chackboxdiv}>
                 <div className={styles.chackboxtxt}>
                              Choose one or more service type{" "}
                              <Tooltip
                                text={"Choose one or more service type"}
                              />
                              <div></div>
                            </div>
                            <div>
                            <div className={styles.chackboxmain}>

                            {
                              IncidentServiceTypes?.map((item) => (
                                <CheckBox name="serviceType" value={item.value} label={item.label}
                                checked={values.serviceType.includes(item.value)}
                                onChange={(e) => {
                                const { checked } = e.target;
                                const newServiceTypes = checked? [...values.serviceType, item.value]: values.serviceType.filter((service) => service !== item.value);
                                setFieldValue("serviceType", newServiceTypes);
                                setServiceType(newServiceTypes)
                              }}
                                />
                              ))}
                              
                            </div>
                            <ErrorMessage name ="serviceType">
                              {(msg)=><ErrorLabel text={msg} />}
                            </ErrorMessage>
                            </div>
                 </div>
            ):null} */}
                  <div>
                    <h2 className={styles.assign}>Assign Modules</h2>
                    {/* <div className={styles.radioGroup}>
                      <div className={styles.radioField}>
                        <Field
                          id="manual"
                          type="radio"
                          name="assignModule"
                          value="manual"
                          className={styles.radioInput}
                        />
                        <label htmlFor="manual" className={styles.radioLabel}>
                          Select Manually
                        </label>
                      </div>

                      <div className={styles.radioField}>
                        <Field
                          id="admin"
                          className={styles.radioInput}
                          type="radio"
                          name="assignModule"
                          value="admin"
                          onClick={(val) => {
                            setFieldValue(
                              "functionalRoles",
                              functionalRoles.map((role) => role.id)
                            );
                          }}
                        />
                        <label htmlFor="admin" className={styles.radioLabel}>
                          Make an admin
                          <br /> (gives access to all modules)
                        </label>
                      </div>
                    </div> */}
                  </div>
                  <fieldset
                    disabled={values.assignModule === "admin" || userData?.email===props.myRights.email}
                    className={styles.checkboxaligngrid}
                  >
                    {rolesToShow?.map((role) => (
                      <CheckBox name="functionalRoles" value={role.id} label={role.name}
                      checked={values.functionalRoles.includes(role.id)}
                      onChange={(e) => {
                        const { checked } = e.target;
                        const newFunctionalRoles = checked
                          ? [...values.functionalRoles, role.id]
                          : values.functionalRoles.filter((r) => r !== role.id);
                        setFieldValue("functionalRoles", newFunctionalRoles);
                      }}
                      />
                    ))}
                  </fieldset>
                  <ErrorMessage name ="functionalRoles">
                    {(msg)=><ErrorLabel text={msg} />}
                  </ErrorMessage>
                  {userData?.email===props.myRights.email&&(<span className={styles.permission}>You cannot update your own permissions.</span>)}
                </fieldset>

                <div>
                  <hr className={styles.separator} />
                  <ButtonWrapper>
                    <BackButton
                      className={styles.backButton}
                      style={styles.submit}
                      title={"Back"}
                      closePopup={close}
                      // onClose={close}
                    />
                    <Submit
                     
                      title={isEdit?"Save Change":"Submit"}
                      isSubmitting={isSubmit}
                      disabled={!isValid || !dirty || ((checkAvailability !== true) && !isEdit)}
                    />
                  </ButtonWrapper>
                </div>
              </Form>
            )}
          </Formik>
        </Sidebar>
      )}
      {/* {isAlert && (
                  
                    <Alert
                      image={message.image}
                      message={message.message}
                      onClose={setIsAlert}
                    />
                 
                )} */}
    </div>
  );
};

export default NewUser;
